import { useEffect, useState } from "react";
import { CtaButton } from "./CtaButton";
import { PRICING, formatIDR } from "@/config/landing";

export function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur-md transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <div>
          <p className="text-[10px] font-medium uppercase tracking-wide text-slate-500">
            Harga peluncuran
          </p>
          <p className="text-base font-extrabold text-slate-900">{formatIDR(PRICING.LAUNCH)}</p>
        </div>
        <CtaButton testid="mobile-sticky-cta-button" size="md" withIcon={false} />
      </div>
    </div>
  );
}
